// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-7c9ff160] .toast-modal-content-box,[data-v-7c9ff160] .vm--modal{--bg-opacity:1;background-color:#eae5df;background-color:rgba(234,229,223,var(--bg-opacity))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
